import { useState } from "react";
import { Star } from "lucide-react";

export const StarPicker = ({ value, onChange, dark = false, testId = "star-picker" }) => {
  const [hover, setHover] = useState(0);
  const color = dark ? "text-[#c9a227]" : "text-[#16301f]";
  const dim = dark ? "text-[#f7f2e7]/25" : "text-[#16301f]/20";
  return (
    <div data-testid={testId} className="flex items-center gap-1.5" onMouseLeave={() => setHover(0)}>
      {[1, 2, 3, 4, 5].map((n) => {
        const on = n <= (hover || value);
        return (
          <button
            key={n}
            type="button"
            data-testid={`${testId}-${n}`}
            aria-label={`${n} star${n > 1 ? "s" : ""}`}
            onMouseEnter={() => setHover(n)}
            onClick={() => onChange(n)}
            className="transition-transform duration-200 hover:scale-110"
          >
            <Star className={`w-7 h-7 ${on ? `${color} fill-current` : dim}`} strokeWidth={1.25} />
          </button>
        );
      })}
    </div>
  );
};

export const Stars = ({ rating, className = "" }) => (
  <span data-testid="review-stars" className={`inline-flex items-center gap-0.5 ${className}`} aria-label={`${rating} out of 5`}>
    {[1, 2, 3, 4, 5].map((n) => (
      <Star
        key={n}
        className={`w-3 h-3 ${n <= rating ? "text-[#16301f] fill-[#16301f]" : "text-[#16301f]/20"}`}
        strokeWidth={1.25}
      />
    ))}
  </span>
);
